<template>
    <div class="wrapper">
        <div class="mask"></div>
        <div class="content">
            <div class="text">{{ text }}</div>
            <div class="schedule">
                <div class="complete" :style="{ width: percent }"></div>
            </div>
        </div>

    </div>

</template>
  
<script>
import { getLogin,postAuthorize, postIxmLogin, postSmkLogin } from '@/api'
export default {
    components: {
    },
    props: {},
    data() {
        return {
            count: 0,
            percent: "",
            path: '/home',
            text:'活动暗藏彩蛋\n请仔细寻找哦'
        };
    },
    watch: {},
    computed: {

    },
    methods: {
        // 获取当前网页的协议+域名
        getPageBaseUrl() {
            var baseURL = window.location.origin + window.location.pathname;
            return baseURL;
        },
        // 获取连接参数正则
        getQueryString(name) {
            var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
            var r = window.location.search.substr(1).match(reg);
            if (r != null) return unescape(r[2]);
            return null;
        },
        //授权获取重定向登录链接
        authorize(applicationType) {
            let  channel = this.getQueryString('channel') || this.$route.query.channel
            postAuthorize({
                redirectUri: this.getPageBaseUrl(),
                type: applicationType,
                state: channel
            }).then(res => {
                let data = res.data.data
                window.location.href = data
            })
        },
        //市民卡获取code
        smkAuthorize() {
            let ua = navigator.userAgent;
            let preloadJs = function () {
                // Promise语法是ES6⽀持的，其他不⽀持的请⾃⾏转成ES5
                return new Promise((resolve, reject) => {
                    if (ua.toLowerCase().indexOf("xmsmk") !== -1) {
                        if (window.UmsApi === undefined) {
                            document.addEventListener(
                                "OnUmsApiReady",
                                function () {
                                    resolve(true);
                                },
                                false
                            );
                        } else {
                            resolve(true);
                        }
                    } else {
                        // ⾮市⺠卡接⼊ 
                        reject("⾮市⺠卡接⼊");
                    }
                });
            };
            preloadJs().then((res) => {
                // sceneType可以传空，特定接入方需要
                var that = this
                function getToken(tokenType, sceneType = "") {
                    UmsApi.globalization.getToken(
                        {
                            tokenType,
                            sceneType,
                        },
                        function (data) {
                            //成功
                            that.login({
                                code: data.token,
                                applicationType: 2
                            })
                        },
                        function (data) {
                            //失败
                        }
                    );
                }
                getToken("full");
                // 调⽤市⺠卡相关⽅法
            });
        },
        //登录
        async login(data) {
            let res = {}
            if (data.applicationType == 2) {
                //市民卡
                res = await postSmkLogin(data)
            } else {
                //微信 or i厦门
                res = await postIxmLogin(data)
            }

            let r = res.data.data
            aplus_queue.push({
                action: 'aplus.setMetaInfo',
                arguments: ['_user_id', r.id] //取值参考见附表1
            });
            aplus_queue.push({
                 action: 'aplus.record',
                 arguments: ['login', 'CLK', {
                    channel:sessionStorage.getItem('channel'),

                 }]
             })
            var token = r.tokenHead + " " + r.token;
            localStorage.setItem("token", token);
            localStorage.setItem("tokenHeader", r.tokenHeader);
            localStorage.setItem("userInfo", JSON.stringify(r));
            this.preload()
            
        },
        getLocationGps(code) {
            let that = this
            upsdk.getLocationGps({
                success: function (res) {
                console.log(res)
                if (typeof res == 'string') {
                    res = JSON.parse(res)
                }
                if(process.env.NODE_ENV !== 'production'||process.env.NODE_ENV == 'test'){
                    that.unionPay(code)
                }else{
                    sessionStorage.setItem('latitude', res.latitude)
                    sessionStorage.setItem('longitude', res.longitude)
                    that.unionPay(code)

                }

                
                },
                fail: function (e) {
                console.log('报错', e)
                if (e.code == 1002) {
                    that.getLocationGps(code)
                } else {
                    that.$toast({
                    className: 'toastName',
                    getContainer: '.wrapper',
                    duration: '5000',
                    message: '抱歉，检测到无法获取手机定位信息，您暂时无法参与本次活动。\n定位功能自查小Tips:\n1.是否开启手机中的定位服务\n2.是否允许云闪付获取您手机的地理位置授权',

                    })
                }
                // that.canDo = true


                }
            });
        },
        //登录
        unionPay() {
            getLogin().then((res) => {
                var data = res.data.data;
                var token = data.tokenHead + " " + data.token;
                localStorage.setItem("token", token);
                localStorage.setItem("tokenHeader", data.tokenHeader);
                localStorage.setItem("userInfo", JSON.stringify(data));
                this.preload()
            })
        },
        preload() {
            this.$toast.clear()
            let imgs = [
                require("@/assets/images/home/cloud1.png"),
                require("@/assets/images/home/cloud2.png"),
                require("@/assets/images/home/cloud3.png"),
                require("@/assets/images/home/decoration.png"),
                require("@/assets/images/home/homeBg.png"),
                require("@/assets/images/home/people.png"),
                require("@/assets/images/home/sunlight.png"),
                require("@/assets/images/home/title.png"),
                require("@/assets/images/home/txt.png"),
                require("@/assets/images/girl1.png"),
                require("@/assets/images/girl2.png"),
                require("@/assets/images/girl3.png"),
                require("@/assets/images/male1.png"),
                require("@/assets/images/male2.png"),
                require("@/assets/images/male3.png"),
                require("@/assets/images/imageCustomizationBg.png"),
                require("@/assets/images/tag.png"),
                require("@/assets/images/logoTitle.png"),
                require("@/assets/images/shareCallingCardBox.png"),
                require("@/assets/images/partOneBg.png"),
            ];
            // const path = require("path");
            // //读取文件的路径 是否遍历文件的子目录 匹配文件正则表达式
            // const files = require.context("@/assets/images", false, /\.(png|jpg|gif|jpeg|webp|ico)$/);
            // //files(key).default拿到该模块的vue对象
            // files.keys().forEach(key => {
            //     const name = path.basename(key);
            //     const a = { url: require("@/assets/images/" + name), name: name }
            //     imgs.push(a.url)
            // });
            for (let img of imgs) {
                let image = new Image();
                image.src = img;
                image.onload = () => {
                    this.count++;
                    // 计算图片加载的百分数，绑定到percent变量
                    let percentNum = Math.floor((this.count / imgs.length) * 100);
                    this.percent = Math.floor(percentNum) + "%";
                    if (percentNum >= 96) {
                        setTimeout(()=>{
                            // if (process.env.NODE_ENV == 'development') {
                            //     this.$router.replace({path:"/home"})
                            // }else{
                                let channel = ''
                                if(this.getQueryString('state') || this.$route.query.state){
                                    channel = this.getQueryString('state') || this.$route.query.state
                                }
                                if(this.getQueryString('channel') || this.$route.query.channel){
                                    channel = this.getQueryString('channel') || this.$route.query.channel
                                }
                                sessionStorage.setItem('channel',channel)
                                console.log('地址',this.getPageBaseUrl() + '#' + this.path+(channel?'?channel=' +channel : ''))
                                window.location.replace(this.getPageBaseUrl() + '#' + this.path+(channel?'?channel=' +channel : ''))
                            // }
                        },1000)
                    }
                };
            }
        },

    },
    created() {
        // require('@/assets/js/vconsole')
        if (process.env.NODE_ENV == 'development') {
            sessionStorage.setItem('channel','cs')
            this.unionPay()
        } else {
            this.$toast.loading({
                duration: 0,
                forbidClick: true
            })
            let applicationType = ''  //渠道：1->APP；2->市民卡；3->PC；4->公众号
            let ua = navigator.userAgent.toLowerCase()
            if (ua.match(/MicroMessenger/i) == "micromessenger") {
                applicationType = 4
            } else if (ua.match(/xmsmk/i) == "xmsmk") {
                applicationType = 2
                return this.smkAuthorize()
            } else {
                applicationType = 1
            } 
            let channel = ''
            if(this.getQueryString('state') || this.$route.query.state){
                channel = this.getQueryString('state') || this.$route.query.state
            }
            if(this.getQueryString('channel') || this.$route.query.channel){
                channel = this.getQueryString('channel') || this.$route.query.channel
            }
            if (this.getQueryString('code') || this.$route.query.code) {
                this.login({
                    redirectUri: this.getPageBaseUrl() +((channel&&applicationType!=4)?'?channel=' +channel : ''),
                    type: applicationType,
                    code: this.getQueryString('code') || this.$route.query.code
                })
            } else {
                this.authorize(applicationType)
            }

        }


    },
    mounted() {
        // document.title = '爱泉州 大乐购'
        // upsdk.setNavigationBarTitle({
        //     title: '爱泉州 大乐购'
        // })

    },
};
</script>
<style scoped  lang="scss">
/* .connection {
    position: relative;
    width: 5.51rem;
    height: 1.04rem;
    background-image: url(../../assets/images/connection.png);
    background-size: 100% auto;
    background-position: bottom;
    background-repeat: no-repeat;
    margin: 0 auto;
    margin-top: -1.03rem;
    z-index: 10;
} */
.wrapper>>>.toastName{
    width: 4.5rem !important;
    text-align: left !important;
}
.wrapper{
    width: 100vw;
    height: 100vh;
    background-size: 100% auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    background: linear-gradient(180deg, #4DAEFF 0%, #E1F9FA 52%, #FFEDCB 100%);
    // backdrop-filter: blur(20px);
    position: relative;
}
.mask{
    width: 100vw;
    height: 100vh;
    background-color: rgba(0,0,0,.4);
    backdrop-filter: blur(20px);
    position: fixed;
    top: 0;
    left: 0;
    z-index: 5;
}
.content{
    width: 100vw;
    height: 100vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 10;

    .text{
        width: 100%;
        color: #fff;
        font-size: .42rem;
        text-align: center;
        white-space: pre-line;
    }
    .schedule{
        width: 6.06rem;
        height: .25rem;
        border-radius: .12rem;
        background-color: #c2bdb0;
        position: absolute;
        bottom: 1rem;
        display: flex;
        align-items: center;
    }
    .complete{
        width: 0;
        height: .18rem;
        background-color: #fff; 
        margin-left: .04rem;
        border-radius: .12rem;
    }

}
</style>